import { DURATION_CODE } from '../constants/addressHistoryFormConstants';

export const withinDuration = (received, duration) => {
  if (!received) return duration === DURATION_CODE.ALL;

  const receivedDate = new Date(received);
  const now = Date.now();
  const days = (now - receivedDate.getTime()) / (1000 * 60 * 60 * 24);

  switch (duration) {
    case DURATION_CODE.DAY:
      return days <= 1;
    case DURATION_CODE.WEEK:
      return days <= 7;
    case DURATION_CODE.MONTH:
      return days <= 30;
    case DURATION_CODE.OVER_MONTH:
      return days > 30;
    default:
      return true;
  }
};
